import styled from "@emotion/styled";
import { Typography } from "@material-ui/core";

export const StyledTypography = styled(Typography)`
  margin-bottom: 10px;
`;
